// Use $ instead of jQuery without replacing global $
(function ($) {
    if ($('.redesign-21 .blog-detail').length === 1) {
        $(document).ready(function ($) {
            var parentElement = $('.redesign-21 .blog-detail .row-wrap');
            var stickyElement = $('.redesign-21 .blog-detail .row-wrap .sidebar .sticky-card');
            var container = $('.redesign-21 .blog-detail .row-wrap .content-wrap');
            var header = $('header');
            var containerHeight = container.height() + 'px';
            var mediaBreakPoint = '(max-width: 980px)';
            var height = stickyElement.height() + 78;
            var heightString = height + 'px';
            var widthString = stickyElement.width() + 86 + 'px';
            var headerHeight = header.height() + 'px';

            function scrollStickySidebar() {
                $(window).scroll(function () {
                    var scroll = $(this).scrollTop() + 90;
                    setParentOrContainerHeight();
                    setStickyElementScrollDefaultStyles();
                    var length = parentElement.height() - stickyElement.height() + parentElement.offset().top;
                    if (!window.matchMedia(mediaBreakPoint).matches) {
                        if (scroll < parentElement.offset().top + 90) {
                            stickyElement.css({
                                'position': 'absolute',
                                'top': '0',
                                'bottom': 'auto'
                            });
                        }
                        else if (scroll > length) {
                            stickyElement.css({
                                'position': 'absolute',
                                'top': 'auto',
                                'bottom': '0'
                            });
                        }
                        else {
                            if (header.hasClass("hide-nav")) {
                                stickyElement.css({
                                    'position': 'fixed',
                                    'top': '0',
                                    'bottom': 'auto'
                                });
                            }
                            else {
                                stickyElement.css({
                                    'position': 'fixed',
                                    'top': '91px',
                                    'bottom': 'auto'
                                });
                            }
                        }
                    }
                    else {
                        setStickyElementMobileDefaultStyles();
                    }
                });
            }

            function setStickyElementScrollDefaultStyles() {
                stickyElement.css({
                    'height': heightString,
                    'width': widthString,
                    'max-width': widthString
                });
            }

            function setStickyElementMobileDefaultStyles() {
                setParentToAutoHeight();

                stickyElement.css({
                    'position': 'relative',
                    'top': 'auto',
                    'bottom': 'auto',
                    'height': 'auto',
                    'width': '100%'
                });
            }

            function setParentOrContainerHeight() {
                if (height < container.height()) {
                    parentElement.css({
                        // 'height': containerHeight
                    });
                }
                else {
                    parentElement.css({
                        // 'height': heightString
                    });
                    container.css({
                        // 'height': heightString
                    });
                }
            }

            function setParentToAutoHeight() {
                parentElement.css({
                    'height': 'auto'
                });
            }

            scrollStickySidebar($);
            $(window).resize(scrollStickySidebar);
        });
    }

})(jQuery);